var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-container",on:{"click":function($event){if($event.target !== $event.currentTarget)return null;}}},[_c('div',{staticClass:"modal"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }